 const getTotalPrizeMoney=(contest_size, entry_fee)=> {
    let contest_value = contest_size * entry_fee;
    let win_percent = 0.8;
    let prize_money = 0;

    if (contest_value < 1000 && contest_size < 10) {
        win_percent = 0.9;
    }

    if (contest_size >= 200 && contest_size <= 20000) {
        if (contest_value >= 5000 && contest_value <= 50000) {
            win_percent = 0.75;
        } else if (contest_value > 50000) {
            win_percent = 0.7;
        }
    }

    prize_money = win_percent * contest_value;

    return parseInt(prize_money);
}
export default getTotalPrizeMoney;